import { useTranslation } from 'react-i18next'
import { UIButton } from 'src/components/ui/Button'
import { track } from 'src/utils/tracker'
import { preloadSignNew } from './SignModalRAC'
import { openSignModal } from './utils'

const SignButton = (props: { size?: 'normal' | 'large' }) => {
  const { t } = useTranslation(['auth'])

  return (
    <div className="flex items-center gap-2" onPointerEnter={preloadSignNew}>
      <UIButton
        variant="outlined"
        onPress={() => {
          track('signup_login_click', { isLogin: true })
          openSignModal(null, { fromPath: 'login' })
        }}
        className="bg-background !border-theme-primary hover:bg-violet-100 dark:hover:bg-slate-800 !text-theme-primary no-underline whitespace-nowrap rounded-full"
        size={props.size}
      >
        {t('auth:sign-in')}
      </UIButton>
    </div>
  )
}

export default SignButton
